import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Automotive  = () => {

  const  servicesFaqData = [
    { 
        question: "What is automotive printing, and where is it used? ", 
        answer: "Using advanced printing technologies, automotive printing involves producing high-quality components, decals, and vehicle branding elements. It is used in manufacturing custom parts, prototyping, and visual branding like decals or vehicle wraps. Automotive printing serves automobile manufacturing, repair services, and marketing industries. Its versatility allows for the customisation of both functional and aesthetic vehicle elements. From enhancing vehicle performance to creating impactful visuals, automotive printing plays a vital role in the industry."
    },
    { 
        question: "What are the benefits of 3D printing automotive components?  ", 
        answer: "3D printing automotive components offer precise and efficient production of custom parts and prototypes. It allows manufacturers to create lightweight yet durable components tailored to specific needs. 3D printing reduces production costs and lead times, making it ideal for rapid prototyping and testing. The technology also enables complex designs that would be challenging to achieve through traditional methods. Additionally, 3D printing supports sustainability by minimising material waste during production."
    },
    { 
        question: "Can Printingy handle bulk automotive printing orders?   ", 
        answer: "Yes, Printingy specialises in bulk automotive printing, providing cost-effective solutions for large-scale production. Bulk printing ensures consistent quality across all products and reduces per-unit costs, making it economical for manufacturers and service providers. Our advanced printing technology provides precision and durability for every order, regardless of size. We deliver bulk orders on time with efficient production processes without compromising quality. Whether for custom branding or manufacturing components, Printingy supports your bulk printing needs."
    },
    { 
        question: "What materials are used for automotive printing?", 
        answer: "Our Printing for Automotive services uses durable materials such as ABS, nylon, and metal alloys for 3D-printed components. These materials are chosen for their strength, flexibility, and resistance to wear, ensuring long-lasting performance in automotive applications. We use high-quality vinyl and UV-resistant inks to maintain vibrant colours and durability for branding elements like decals and wraps. These materials are carefully selected to meet the functional and aesthetic requirements of the automotive industry."
    },
    { 
        question: "What industries and businesses benefit from automotive printing services?  ", 
        answer: "Automobile manufacturers, repair services, and marketing agencies benefit significantly from automotive printing services. Manufacturers use 3D printing for prototyping and producing custom parts. Repair services rely on printed components for precise and efficient replacements. Marketing agencies utilise custom branding elements like vehicle wraps and decals to enhance brand visibility. Whether for production, repair, or promotion, automotive printing provides innovative and cost-effective solutions for various industry needs."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing for Automotive');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes


  return (
    <div>
    <MetaManager 
  title=" Professional Automotive Printing Services"
  description="High-quality printing for automotive needs, including custom designs and 3D automotive printing. Bulk automotive printing solutions for businesses and manufacturers."
  keywords="Printing for Automotive,
Automotive Printing,
3D Printing Automotive,
Custom Automotive Printing

"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing for Automotive  </h1>
              <h2 className="text-muted">Custom automotive printing solutions for manufacturing and branding   </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Automotive printing involves advanced technologies to produce durable, high-quality vehicle designs and components. Printingy specialises in Printing for Automotive, offering reliable and precise automotive printing solutions for businesses and manufacturers.</p>
          <p>Our services include 3D printing automotive components for custom parts, prototyping, and repair needs. Additionally, we provide custom printing for branding elements such as decals, wraps, and labels, ensuring your vehicles or products stand out. Printingy delivers innovative and cost-effective solutions tailored to your requirements, whether for production, maintenance, or marketing purposes.</p>
          
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Automotive Printing Solutions   </h2>
                <h3 className="large-hed">High-quality, durable printing for automotive applications </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing for Automotive for manufacturing and branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Precision automotive printing services with advanced technology.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional 3D printing automotive components for customisation and prototyping.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials ensure long-lasting results for automotive applications.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-resolution printing for branding elements like wraps, decals, and labels.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Cost-effective solutions for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for production and delivery.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by automotive businesses, manufacturers, and service providers.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/automotive.jpg" // Path relative to the public folder
                  alt="Professional printing for automotive solutions"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Automotive Printing Delivered On Time</h2>
            <h3 className="small-hed">Focus on your operations while we manage your printing needs </h3>
            <p>At Printingy, we combine cutting-edge technology with premium materials to deliver exceptional automotive printing solutions. Whether manufacturing components or creating custom branding elements, our 3D printing automotive services ensure precision and durability.
            </p>
            <p>We prioritise efficiency and quality, guaranteeing timely delivery for all bulk and customised orders. Partner with Printingy for reliable automotive printing services that enhance your operations and branding.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Automotive;
